import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Alert from "@shared/v2/Alert";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import TextInput from "@shared/v2/TextInput";
import { produce } from "immer";
import SocialIcon from "./SocialIcon";
import { updatePersonPromise } from "../actions/updatePerson";
import { closeEditSocialMediaModal, updatePersonData } from "../actions/personDetailActionCreators";

const EditSocialMediaForm = () => {
  const dispatch = useDispatch();
  const person = useSelector((state) => state.personDetail.person);
  const [editablePerson, setEditablePerson] = useState(person);
  const [errors, setErrors] = useState(null);

  useEffect(() => {
    setEditablePerson(person);
  }, [person]);

  const handleEditableValueChange = (value, key) => {
    setEditablePerson(
      produce(editablePerson, (draft) => {
        // eslint-disable-next-line no-param-reassign
        draft.data.attributes[key].value = value;
      }),
    );
  };

  const saveChanges = () => {
    updatePersonPromise(editablePerson)
      .then((r) => {
        dispatch(updatePersonData(r.data));
        dispatch(closeEditSocialMediaModal());
      })
      .catch((err) => {
        setErrors(err.response.data.errors || ["Something went wrong..."]);
      });
  };

  return (
    <>
      <Modal.Body className="tw-flex-1 tw-flex tw-flex-col tw-gap-[16px] tw-overflow-auto">
        {errors && (
          <Alert variant="error">
            {errors.map((error) => (
              <span>
                <strong>Error: </strong> {error}
                <br />
              </span>
            ))}
          </Alert>
        )}

        <div className="tw-flex tw-items-end tw-gap-[16px]">
          <SocialIcon link={editablePerson.data.attributes.facebook.value} icon="fa fa-facebook" />
          <TextInput
            containerClassName="tw-flex-1"
            label="Facebook"
            value={editablePerson.data.attributes.facebook.value}
            placeholder="Facebook profile page URL"
            onChange={(e) => handleEditableValueChange(e.target.value, "facebook")}
          />
        </div>

        <div className="tw-flex tw-items-end tw-gap-[16px]">
          <SocialIcon link={editablePerson.data.attributes.twitter.value} icon="fab fa6-x-twitter" />
          <TextInput
            containerClassName="tw-flex-1"
            label="X (Twitter)"
            value={editablePerson.data.attributes.twitter.value}
            placeholder="X profile page URL"
            onChange={(e) => handleEditableValueChange(e.target.value, "twitter")}
          />
        </div>

        <div className="tw-flex tw-items-end tw-gap-[16px]">
          <SocialIcon link={editablePerson.data.attributes.linkedin.value} icon="fa fa-linkedin" />
          <TextInput
            containerClassName="tw-flex-1"
            label="LinkedIn"
            value={editablePerson.data.attributes.linkedin.value}
            placeholder="LinkedIn profile page URL"
            onChange={(e) => handleEditableValueChange(e.target.value, "linkedin")}
          />
        </div>

        <div className="tw-flex tw-items-end tw-gap-[16px]">
          <SocialIcon link={editablePerson.data.attributes.instagram.value} icon="fa fa-instagram" />
          <TextInput
            containerClassName="tw-flex-1"
            label="Instagram"
            value={editablePerson.data.attributes.instagram.value}
            placeholder="Instagram profile page URL"
            onChange={(e) => handleEditableValueChange(e.target.value, "instagram")}
          />
        </div>

        <div className="tw-flex tw-items-end tw-gap-[16px]">
          <SocialIcon link={editablePerson.data.attributes.youtube.value} icon="fab fa6-youtube" />
          <TextInput
            containerClassName="tw-flex-1"
            label="Youtube"
            value={editablePerson.data.attributes.youtube.value}
            placeholder="Youtube profile page URL"
            onChange={(e) => handleEditableValueChange(e.target.value, "youtube")}
          />
        </div>

        <div className="tw-flex tw-items-end tw-gap-[16px]">
          <SocialIcon link={editablePerson.data.attributes.tiktok.value} icon="fab fa6-tiktok" />
          <TextInput
            containerClassName="tw-flex-1"
            label="TikTok"
            value={editablePerson.data.attributes.tiktok.value}
            placeholder="TikTok profile page URL"
            onChange={(e) => handleEditableValueChange(e.target.value, "tiktok")}
          />
        </div>

        <div className="tw-flex tw-items-end tw-gap-[16px]">
          <SocialIcon link={editablePerson.data.attributes.pinterest.value} icon="fab fa6-pinterest" />
          <TextInput
            containerClassName="tw-flex-1"
            label="Pinterest"
            value={editablePerson.data.attributes.pinterest.value}
            placeholder="Pinterest profile page URL"
            onChange={(e) => handleEditableValueChange(e.target.value, "pinterest")}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
        <Button size="medium" schema="tertiary" onClick={() => dispatch(closeEditSocialMediaModal())}>
          Cancel
        </Button>
        <Button size="medium" onClick={saveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </>
  );
};

export default EditSocialMediaForm;
